/* src/app/main/matching/list/matching-list.component.scss */
/*# sourceMappingURL=matching-list.component-7UFXGLFQ.css.map */
